import React from 'react';

const shows = [
  {
    title: 'Τίτλος Παράστασης',
    subtitle: 'Υπότιτλος ή Συγγραφέας',
    year: '2024',
    image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=800&q=80',
    description: 'Σύντομη περιγραφή της παράστασης. Πληροφορίες για την παραγωγή, τους συντελεστές και το καλλιτεχνικό όραμα.',
    tag: 'Νέα Παραγωγή',
  },
  {
    title: 'Τίτλος Παράστασης',
    subtitle: 'Υπότιτλος ή Συγγραφέας',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1598387846148-47e82ee120cc?w=800&q=80',
    description: 'Σύντομη περιγραφή της παράστασης. Πληροφορίες για την παραγωγή, τους συντελεστές και το καλλιτεχνικό όραμα.',
    tag: 'Αναβίωση',
  },
  {
    title: 'Τίτλος Παράστασης',
    subtitle: 'Υπότιτλος ή Συγγραφέας',
    year: '2022',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    description: 'Σύντομη περιγραφή της παράστασης. Πληροφορίες για την παραγωγή, τους συντελεστές και το καλλιτεχνικό όραμα.',
    tag: 'Πρεμιέρα',
  },
];

export default function Shows() {
  return (
    <section style={{ padding: '120px 64px', maxWidth: '1200px', margin: '0 auto' }}>
      <PageHeader title="Παραστάσεις" subtitle="Το Έργο μας" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '80px' }}>
        {shows.map((show, i) => (
          <ShowItem key={i} show={show} reverse={i % 2 !== 0} />
        ))}
      </div>
    </section>
  );
}

function ShowItem({ show, reverse }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2px',
      direction: reverse ? 'rtl' : 'ltr',
    }}>
      <div style={{ overflow: 'hidden', aspectRatio: '4/3' }}>
        <img
          src={show.image}
          alt={show.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'grayscale(20%)',
            transition: 'transform 0.6s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        />
      </div>

      <div style={{
        direction: 'ltr',
        background: 'var(--off-white)',
        padding: '56px 48px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '20px' }}>
          <span style={{
            fontSize: '0.6rem',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'var(--accent)',
            border: '1px solid var(--accent)',
            padding: '3px 10px',
          }}>{show.tag}</span>
          <span style={{
            fontSize: '0.68rem',
            letterSpacing: '0.1em',
            color: 'var(--mid-gray)',
            fontFamily: 'var(--font-display)',
            fontStyle: 'italic',
          }}>{show.year}</span>
        </div>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: '2.2rem',
          fontWeight: 400,
          letterSpacing: '0.04em',
          color: 'var(--black)',
          lineHeight: 1.1,
          marginBottom: '8px',
        }}>{show.title}</h2>

        <p style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1rem',
          fontStyle: 'italic',
          color: 'var(--mid-gray)',
          marginBottom: '24px',
        }}>{show.subtitle}</p>

        <p style={{
          fontSize: '0.82rem',
          lineHeight: 1.9,
          color: 'var(--dark-gray)',
          fontWeight: 300,
          letterSpacing: '0.03em',
        }}>{show.description}</p>
      </div>

      <style>{`
        @media (max-width: 768px) {
          div[style*="grid-template-columns: 1fr 1fr"] {
            grid-template-columns: 1fr !important;
            direction: ltr !important;
          }
        }
      `}</style>
    </div>
  );
}

function PageHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: '72px' }}>
      <p style={{
        fontSize: '0.62rem',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '12px',
      }}>{subtitle}</p>
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        fontWeight: 300,
        letterSpacing: '0.04em',
        color: 'var(--black)',
        lineHeight: 1,
      }}>{title}</h1>
      <div style={{ width: '40px', height: '1px', background: 'var(--accent)', marginTop: '20px' }} />
    </div>
  );
}
